import { css } from '@/styled-system/css';

export const paginationRootStyles = css.raw({
  'display': 'block',
  'marginInline': 'auto',
  'width': '100%',
  'userSelect': 'none',
  '& > .c11n_divider:is(:first-child)': {
    marginBlockEnd: 'default',
  },
});
